import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardBody, Table, ModalHeader, ModalBody, FormGroup, Button, Modal, Label, Input, TabContent, TabPane, CardHeader } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import jsPDF from 'jspdf'
import * as html2canvas from 'html2canvas';
import { useTranslation } from "react-i18next";
import { ReactBingmaps } from "react-bingmaps";
import "./styles.css"

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const Trip = (props) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);
  const [clientHeight, setclientHeight] = useState("")
  const [buyer_detail, setbuyer_detail] = useState([])
  const [Driver_detail, setDriver_detail] = useState([])
  const [vehicle_detail, setvehicle_detail] = useState([])
  const [Inventory_detail, setInventory_detail] = useState([])
  const [buyer_id, setbuyer_id] = useState("")
  const [buyer_name, setbuyer_name] = useState("")
  const [buyer_address, setbuyer_address] = useState("")
  const [buyergst, setbuyergst] = useState("")

  const [supplier_name, setsupplier_name] = useState("")
  const [supplier_address, setsupplier_address] = useState("")
  const [suppliergst, setsuppliergst] = useState("")
  const [supplier_id, setsupplier_id] = useState("")
  const [vehicle_id, setvehicle_id] = useState("")
  const [return_vehicle_id, setreturn_vehicle_id] = useState("")
  const [driver_id, setdriver_id] = useState("")
  const [driver_name, setdriver_name] = useState("")
  const [return_driver_id, setreturn_driver_id] = useState("")
  const [return_driver_name, setreturn_driver_name] = useState("")
  const [inventory_id, setinventory_id] = useState("")
  const [inventory_quantity, setinventory_quantity] = useState("")
  const [inventory_mainquantity, setinventory_mainquantity] = useState("")
  const [inventory_unit, setinventory_unit] = useState("")
  const [inventory_totalquantity, setinventory_totalquantity] = useState("")
  const [inventory_sold, setinventory_sold] = useState("")
  const [transport_charges, settransport_charges] = useState("")
  const [transport_distance, settransport_distance] = useState("")
  const [return_transport_charges, setreturn_transport_charges] = useState("")
  const [return_transport_distance, setreturn_transport_distance] = useState("")

  const [inventory_type, setinventory_type] = useState("")
  const [tonnage_buyer, settonnage_buyer] = useState("100")
  const [return_tonnage_buyer, setreturn_tonnage_buyer] = useState("100")

  const [tonnage_supplier, settonnage_supplier] = useState("100")
  const [return_tonnage_supplier, setreturn_tonnage_supplier] = useState("100")
  const [vehicle_type, setvehicle_type] = useState("")
  const [return_vehicle_type, setreturn_vehicle_type] = useState("")
  const [trip_date, settrip_date] = useState("")
  const [return_trip_date, setreturn_trip_date] = useState("")
  const [trip_amount, settrip_amount] = useState("")
  const [return_trip_amount, set_return_amount] = useState("")
  const [vehicle_tonnage, setvehicle_tonnage] = useState("")
  const [return_vehicle_tonnage, setreturn_vehicle_tonnage] = useState("")
  const [vehicle_number, setvehicle_number] = useState("")
  const [return_vehicle_number, setreturn_vehicle_number] = useState("")

  const [payment_by, setpayment_by] = useState("")
  const [return_payment_by, setreturn_payment_by] = useState("")
  const [paid_at, setpaid_at] = useState("")
  const [return_paid_at, setreturn_paid_at] = useState("")
  const [transaction_id, settransaction_id] = useState("")
  const [return_transaction_id, setreturn_transaction_id] = useState("")
  const [delivery_status, setdelivery_status] = useState("")
  const [return_delivery_status, setreturn_delivery_status] = useState("")
  const [payment_status, setpayment_status] = useState("")
  const [return_payment_status, setreturn_payment_status] = useState("")
  const [return_load, setreturn_load] = useState("")
  const [return_mainquantity, setreturn_mainquantity] = useState("")
  const [return_load_unit, setreturn_load_unit] = useState("")
  const [return_load_total_quantity, setreturn_load_total_quantity] = useState("")
  const [return_load_sold, setreturn_load_sold] = useState("")
  const [return_inventory, setreturn_inventory] = useState("")
  const [return_costperunit, setreturn_costperunit] = useState("")
  const [return_inventory_id, setreturn_inventory_id] = useState("")
  const [inventory_costperunit, setinventory_costperunit] = useState("")
  const [return_buyer, setreturn_buyer] = useState("")
  const [return_buyer_id, setreturn_buyer_id] = useState("")
  const [return_buyer_address, setreturn_buyer_address] = useState("")
  const [return_buyer_gst, setreturn_buyer_gst] = useState("")
  const [edittype, setedittype] = useState("")

  const [editid, seteditid] = useState("")
  const [Large, setLarge] = useState(false);
  const [tabtripdate, settabtripdate] = useState("")
  const [tabvehicleid, settabvehicleid] = useState("")
  const [tabdriverid, settabdriverid] = useState("")
  const [tabbuyerid, settabbuyerid] = useState("")

  const [tabpayment, settabpayment] = useState("")
  const [supplier_coordinate, setsupplier_coordinate] = useState("")
  const [tabdelivery, setabdelivery] = useState("")
  const [trip_detail, settrip_detail] = useState([])
  const [trip_status, settrip_status] = useState(0)
  const [return_trip_status, setreturn_trip_status] = useState(false)
  const [trip_type, settrip_type] = useState([{
    trip_name: "One Way Trip",
  }])
  const [activeTab1, setActiveTab1] = useState('1');
  const { t } = useTranslation();

  const [rightSidebar, setRightSidebar] = useState(true);
  const openCustomizer = (type) => {
    settabtripdate("")
    setabdelivery("")
    setActiveTab1(type)
    setRightSidebar(!rightSidebar)
    if (rightSidebar) {
      document.querySelector(".customizer-contain").classList.add('open');

    }
  }



  const LargeModaltoggle = () => {
    settabbuyerid("")
    settabtripdate("")
    settabvehicleid("")
    settabdriverid("")

    setreturn_load_unit("")
    setinventory_unit("")
    settabpayment("")
    setabdelivery("")
    setbuyer_id("")
    setbuyer_name("")
    setbuyer_address("")
    setvehicle_id("")
    setreturn_vehicle_id("")
    setdriver_id("")
    setreturn_driver_id("")
    setdriver_name("")
    setreturn_driver_name("")
    setinventory_id("")
    setinventory_quantity("")
    setinventory_type("")
    settonnage_buyer("100")
    setreturn_tonnage_buyer("100")
    settonnage_supplier("100")
    setreturn_tonnage_supplier("100")
    setvehicle_tonnage("")
    setreturn_vehicle_tonnage("")
    setpayment_by("")
    setreturn_payment_by("")
    setpaid_at("")
    setreturn_paid_at("")
    setreturn_load_total_quantity("")
    setreturn_load_sold("")
    setinventory_totalquantity("")
    setinventory_sold("")
    settransaction_id(`${new Date().toLocaleDateString()}`)
    setreturn_transaction_id("")
    setreturn_transaction_id("")
    setdelivery_status("IN-TRANSIT")
    setreturn_delivery_status("IN-TRANSIT")
    setpayment_status("Pending")
    setreturn_payment_status("Pending")
    setreturn_load("")
    setreturn_inventory("")
    setreturn_inventory_id("")
    settransport_charges("")
    setreturn_transport_charges("")
    settransport_distance("")
    setreturn_transport_distance("")
    setbuyergst("")
    setreturn_buyer("")
    settrip_amount("")
    set_return_amount("")
    settrip_date(new Date().toJSON().slice(0, 10).replace(/-/g, '-'))
    setreturn_trip_date(new Date().toJSON().slice(0, 10).replace(/-/g, '-'))
    setreturn_mainquantity("")
    setinventory_mainquantity("")
    setreturn_buyer("")
    setreturn_trip_status(true)
    settrip_status(0)
    setreturn_buyer_id("")
    setreturn_buyer_gst("")
    setreturn_buyer_address("")

    setLarge(!Large)
  };

  useEffect(() => {

    setclientHeight(window.innerHeight * 0.77)


  }, [clientHeight])

  useEffect(() => {

    if (localStorage.getItem("usertype") != "Supplier") {
      window.history.back()
    }
    getBuyerdetail()
    getDriverdetail()
    getvehicledetail()
    getInventorydetail()
    getSupplierdetail()
    getTripDetail()
  }, [])
  async function getSupplierdetail() {
    const { data: supplier_details, error } = await supabase
      .from('supplier_details')
      .select('*')
      .eq('man_email', localStorage.getItem("useremail"))

    if (supplier_details !== null && supplier_details.length > 0) {
      setsupplier_address(supplier_details[0].man_address)
      setsupplier_name(supplier_details[0].man_name)
      setsupplier_id(supplier_details[0].man_id)
      setsuppliergst(supplier_details[0].man_gstnumber)
      setsupplier_coordinate(supplier_details[0].supplier_coordinate)


    } else {
      setsupplier_address("")
      setsupplier_id("")
      setsupplier_name("")
      setsuppliergst("")
      setsupplier_coordinate("")
    }
  }
  async function getBuyerdetail() {
    let { data: Buyer_Details, error } = await supabase
      .from('Buyer_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))

    if (Buyer_Details !== null && Buyer_Details.length > 0) {
      setbuyer_detail(Buyer_Details)
    } else {
      // toast.error("No Buyer Details Found")
      setbuyer_detail([])
    }
  }

  async function getInventorydetail() {
    let { data: Inventory_Details, error } = await supabase
      .from('inventory_details')
      .select('*')
      .eq("created_By", localStorage.getItem("useremail"))

    if (Inventory_Details !== null && Inventory_Details.length > 0) {
      setInventory_detail(Inventory_Details)
    } else {
      // toast.error("No Inventory Details Found")
      setInventory_detail([])
    }
  }
  async function getDriverdetail() {
    let { data: driver_details, error } = await supabase
      .from('driver_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))

    if (driver_details !== null && driver_details.length > 0) {
      setDriver_detail(driver_details)
    } else {
      // toast.error("No Driver Details Found")
      setDriver_detail([])
    }
  }
  async function getvehicledetail() {
    let { data: vehicle_details, error } = await supabase
      .from('vehicle_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))

    if (vehicle_details !== null && vehicle_details.length > 0) {
      setvehicle_detail(vehicle_details)
    } else {
      // toast.error("No vehicle Details Found")
      setvehicle_detail([])
    }
  }
  async function getTripDetail() {
    settabbuyerid("")
    settabtripdate("")
    settabvehicleid("")
    settabdriverid("")

    settabpayment("")
    setabdelivery("")
    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq("createdBy", localStorage.getItem("useremail"))
      .order('id', { ascending: false })

    if (trip_Details !== null && trip_Details.length > 0) {
      settrip_detail(trip_Details)


    } else {
      // toast.error("No Buyer Details Found")
      settrip_detail([])

    }
  }
  const DeleteUser = async (tripid) => {

    let { data: trip_details, error } = await supabase
      .from('trip_details')
      .delete()
      .eq('trip_id', tripid)

    if (trip_details !== null && trip_details.length > 0) {
      let { data: invoice_detail, error } = await supabase
        .from('invoice_details')
        .delete()
        .eq('invoice_id', trip_details[0].invoice_id)
      if (invoice_detail !== null && invoice_detail.length > 0) {
        let { data: reinvoice_detail, reerror } = await supabase
          .from('invoice_details')
          .delete()
          .eq('invoice_id', trip_details[0].return_invoice_id)
        if (reinvoice_detail !== null && reinvoice_detail.length > 0) {
          let { data: veinvoice_detail, veerror } = await supabase
            .from('vehicle_invoice_details')
            .delete()
            .eq('vehicle_invoice_id', trip_details[0].vehicle_invoice_id)
          if (veinvoice_detail !== null && veinvoice_detail.length > 0) {
            let { data: reveinvoice_detail, reveerror } = await supabase
              .from('vehicle_invoice_details')
              .delete()
              .eq('vehicle_invoice_id', trip_details[0].return_vehicle_invoice_id)
            if (reveinvoice_detail !== null && reveinvoice_detail.length > 0) {


              toast.success("Trip Deleted Successfully")
              getTripDetail()
            } else {
              toast.success("Trip Deleted Successfully")
              getTripDetail()
            }
          } else {
            toast.success("Trip Deleted Successfully")
            getTripDetail()
          }
        } else {
          toast.success("Trip Deleted Successfully")
          getTripDetail()
        }


      } else {
        toast.success("Trip Deleted Successfully")
        getTripDetail()
      }


    } else {
      toast.error("Error in Deleting Trip")
    }

  }
  const UpdateUser = async (tripid) => {
    setLarge(!Large)
    setedittype("updated")
    seteditid(tripid)
    setreturn_trip_status(true)
    let { data: trip_details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq('trip_id', tripid)

    if (trip_details !== null && trip_details.length > 0) {
      setbuyer_id(trip_details[0].customer_id)
      updateBuyerdetail(trip_details[0].customer_id)

      setvehicle_id(trip_details[0].vehicle_id)
      updatevehicledetail(trip_details[0].vehicle_id)
      setdriver_id(trip_details[0].driverid)
      updateDriverdetail(trip_details[0].driverid)
      setinventory_id(trip_details[0].inventory_id)
      updateInventorydetail(trip_details[0].inventory_id)
      setinventory_quantity(trip_details[0].inventory_quantity)
      setinventory_mainquantity(trip_details[0].inventory_quantity)
      setinventory_type(trip_details[0].inventory_type)
      settonnage_buyer(trip_details[0].tonnage_customer)
      settonnage_supplier(trip_details[0].tonnage_man)

      setpayment_by(trip_details[0].payment_by)
      setpaid_at(trip_details[0].paid_at)
      settransaction_id(trip_details[0].transaction_id)
      setdelivery_status(trip_details[0].delivery_status)
      setpayment_status(trip_details[0].payment_status)

      settransport_charges(trip_details[0].transport_charges)
      settransport_distance(trip_details[0].transport_distance)



      settrip_amount(trip_details[0].trip_amount)

      settrip_date(trip_details[0].trip_date)



    }
  }
  const randomUsername = () => {
    return `${Date.now().toString().substr(-4)}`;
  };
  async function RegisterUser(type, id) {
    if (type === "new") {
      if (trip_status === 0) {
        if (trip_date === "") {
          toast.error("Please Select Trip Date")
        } else if (inventory_id === "") {
          toast.error("Please Select Inventory")
        } else if (inventory_quantity === "") {
          toast.error("Please Enter Inventory Quantity")
        } else if (inventory_quantity > inventory_totalquantity) {
          toast.error(`Inventory Quantity not more than ${inventory_totalquantity}`)
        } else if (driver_id === "") {
          toast.error("Please Select Driver")
        } else if (vehicle_id === "") {
          toast.error("Please Select Vehicle")
        } else if (buyer_id === "") {
          toast.error("Please Select Buyer")
        } else if (tonnage_buyer === "") {
          toast.error("Please Enter Buyer Tonnage")
        } else if (tonnage_supplier === "") {
          toast.error("Please Enter Supplier Tonnage")
        } else if (trip_amount === "") {
          toast.error("Please Enter Trip Amount")
        } else if (transport_distance === "") {
          toast.error("Please Enter Transport Distance")


        } else if (transport_charges === "") {
          toast.error("Please Enter Transport Charges")
        } else if (delivery_status === "") {
          toast.error("Please Select Delivery Status")
        } else if (payment_status === "") {
          toast.error("Please Select Payment Status")
        } else {


          await supabase
            .from('inventory_details')
            .update(
              { inventory_quantity: (parseInt(inventory_totalquantity) - parseInt(inventory_quantity)), inventory_sold: (parseInt(inventory_sold) + parseInt(inventory_quantity)) },
            )
            .eq('inventory_id', inventory_id)

          var trip_id = `trip${randomUsername()}`

          var invoice_id = `invoice${randomUsername()}`

          const { data, error } = await supabase
            .from('trip_details')
            .insert([
              { trip_id: trip_id, customer_id: buyer_id, supplier_coordinate: supplier_coordinate, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: buyer_name, customer_address: buyer_address, customer_deliveryaddress: buyer_address, man_name: supplier_name, man_address: supplier_address, vehicle_id: vehicle_id, driverid: driver_id, vehicle_number: vehicle_number, driver_name: driver_name, inventory_id: inventory_id, inventory_quantity: inventory_quantity, transport_distance: transport_distance, transport_charges: transport_charges, inventory_type: inventory_type, tonnage_man: tonnage_supplier, tonnage_customer: tonnage_buyer, tonnage_vehicle: vehicle_tonnage, invoice_id: invoice_id, payment_by: payment_by, paid_at: paid_at, transaction_id: transaction_id, delivery_status: delivery_status, payment_status: payment_status, trip_date: trip_date, trip_amount: trip_amount }
            ])

          if (data !== null) {

            const { data: invoice_detail, error1 } = await supabase
              .from('invoice_details')
              .insert([
                { invoice_id: invoice_id, invoice_date: trip_date, inventory_unit: inventory_unit, trip_id: trip_id, customer_gstnumber: buyergst, man_gstnumber: suppliergst, customer_id: buyer_id, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: buyer_name, customer_address: buyer_address, customer_deliveryaddress: buyer_address, man_name: supplier_name, man_address: supplier_address, transport_distance: transport_distance, transport_charges: transport_charges, inventory_costperunit: inventory_costperunit, inventory_quantity: inventory_quantity, inventory_type: inventory_type, inventory_cost: (parseInt(inventory_costperunit) * parseInt(inventory_quantity)), total_cost: ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) + ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) * 18) / 100), payment_type: payment_by, paid_at: paid_at, transaction_id: transaction_id, payment_status: payment_status },
              ])

            if (invoice_detail !== null && invoice_detail.length > 0) {
              toast.success(`Trip Created Successfully`)
              setLarge(!Large)
              getTripDetail()
            } else {
              toast.error(`Error in Creating Trip`)
              await supabase
                .from('trip_details')
                .delete()
                .eq('trip_id', trip_id)
            }




          } else {
            toast.error(error.message)
          }

        }
      } else {
        if (trip_date === "") {
          toast.error("Please Select Trip Date")
        } else if (inventory_id === "") {
          toast.error("Please Select Inventory")
        } else if (inventory_quantity === "") {
          toast.error("Please Enter Inventory Quantity")
        } else if (inventory_quantity > inventory_totalquantity) {
          toast.error(`Inventory Quantity not more than ${inventory_totalquantity}`)
        } else if (driver_id === "") {
          toast.error("Please Select Driver")
        } else if (vehicle_id === "") {
          toast.error("Please Select Vehicle")
        } else if (buyer_id === "") {
          toast.error("Please Select Buyer")
        } else if (tonnage_buyer === "") {
          toast.error("Please Enter Buyer Tonnage")
        } else if (tonnage_supplier === "") {
          toast.error("Please Enter Supplier Tonnage")
        } else if (trip_amount === "") {
          toast.error("Please Enter Trip Amount")
        } else if (transport_distance === "") {
          toast.error("Please Enter Transport Distance")


        } else if (transport_charges === "") {
          toast.error("Please Enter Transport Charges")
        } else if (delivery_status === "") {
          toast.error("Please Select Delivery Status")
        } else if (payment_status === "") {
          toast.error("Please Select Payment Status")
        } else if (return_trip_date === "") {
          toast.error("Please Select Return Trip Date")
        } else if (return_load === "") {
          toast.error("Please Select Return Load")
        } else if (return_load > return_load_total_quantity) {
          toast.error(`Return Load Quantity not more than ${return_load_total_quantity}`)
        } else if (return_inventory_id === "") {
          toast.error("Please Select Return Inventory")
        } else if (return_driver_id === "") {
          toast.error("Please Select Return Driver")
        } else if (return_driver_name === "") {
          toast.error("Please Select Return Vehicle")
        } else if (return_buyer_id === "") {
          toast.error("Please Select Return Buyer")
        } else if (return_tonnage_buyer === "") {
          toast.error("Please Enter Return Buyer Tonnage")
        } else if (return_tonnage_supplier === "") {
          toast.error("Please Enter Return Supplier Tonnage")
        } else if (return_trip_amount === "") {
          toast.error("Please Enter Return Trip Amount")
        } else if (return_transport_distance === "") {
          toast.error("Please Enter Return Transport Distance")


        } else if (return_transport_charges === "") {
          toast.error("Please Enter Return Transport Charges")
        } else if (return_delivery_status === "") {
          toast.error("Please Select Return Delivery Status")
        } else if (return_payment_status === "") {
          toast.error("Please Select Return Payment Status")
        } else {


          await supabase
            .from('inventory_details')
            .update(
              { inventory_quantity: (parseInt(inventory_totalquantity) - parseInt(inventory_quantity)), inventory_sold: (parseInt(inventory_sold) + parseInt(inventory_quantity)) },
            )
            .eq('inventory_id', inventory_id)
          await supabase
            .from('inventory_details')
            .update(
              { inventory_quantity: (parseInt(return_load_total_quantity) - parseInt(return_load)), inventory_sold: (parseInt(return_load_sold) + parseInt(return_load)) },
            )
            .eq('inventory_id', return_inventory_id)
          var trip_id = `trip${randomUsername()}`
          var return_trip_id = `returntrip${randomUsername()}`
          var invoice_id = `invoice${randomUsername()}`
          var return_invoice_id = `returninvoice${randomUsername()}`
          const { data, error } = await supabase
            .from('trip_details')
            .insert([
              { trip_id: trip_id, customer_id: buyer_id, supplier_coordinate: supplier_coordinate, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: buyer_name, customer_address: buyer_address, customer_deliveryaddress: buyer_address, man_name: supplier_name, man_address: supplier_address, vehicle_id: vehicle_id, driverid: driver_id, vehicle_number: vehicle_number, driver_name: driver_name, inventory_id: inventory_id, inventory_quantity: inventory_quantity, transport_distance: transport_distance, transport_charges: transport_charges, inventory_type: inventory_type, tonnage_man: tonnage_supplier, tonnage_customer: tonnage_buyer, tonnage_vehicle: vehicle_tonnage, invoice_id: invoice_id, payment_by: payment_by, paid_at: paid_at, transaction_id: transaction_id, delivery_status: delivery_status, payment_status: payment_status, trip_date: trip_date, trip_amount: trip_amount }
            ])

          if (data !== null) {
            if (return_load !== "") {
              const { redata, reerror } = await supabase
                .from('trip_details')
                .insert([
                  { trip_id: return_trip_id, customer_id: return_buyer_id, supplier_coordinate: supplier_coordinate, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: return_buyer, customer_address: return_buyer_address, customer_deliveryaddress: return_buyer_address, man_name: supplier_name, man_address: supplier_address, vehicle_id: return_vehicle_id, driverid: return_driver_id, vehicle_number: return_vehicle_number, driver_name: return_driver_name, inventory_id: return_inventory_id, inventory_quantity: return_load, transport_distance: return_transport_distance, transport_charges: return_transport_charges, inventory_type: return_inventory, tonnage_man: return_tonnage_supplier, tonnage_customer: return_tonnage_buyer, tonnage_vehicle: vehicle_tonnage, invoice_id: return_invoice_id, payment_by: return_payment_by, paid_at: return_paid_at, transaction_id: return_transaction_id, delivery_status: return_delivery_status, payment_status: return_payment_status, trip_amount: return_trip_amount, trip_date: return_trip_date },
                ])

              if (redata !== null) {
                const { data: invoice_detail, error1 } = await supabase
                  .from('invoice_details')
                  .insert([
                    { invoice_id: invoice_id, invoice_date: trip_date, inventory_unit: inventory_unit, trip_id: trip_id, customer_gstnumber: buyergst, man_gstnumber: suppliergst, customer_id: buyer_id, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: buyer_name, customer_address: buyer_address, customer_deliveryaddress: buyer_address, man_name: supplier_name, man_address: supplier_address, transport_distance: transport_distance, transport_charges: transport_charges, inventory_costperunit: inventory_costperunit, inventory_quantity: inventory_quantity, inventory_type: inventory_type, inventory_cost: (parseInt(inventory_costperunit) * parseInt(inventory_quantity)), total_cost: ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) + ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) * 18) / 100), payment_type: payment_by, paid_at: paid_at, transaction_id: transaction_id, payment_status: payment_status },
                  ])

                if (invoice_detail !== null && invoice_detail.length > 0) {
                  if (return_load !== "") {

                    const { data: return_invoice_detail, return_error1 } = await supabase
                      .from('invoice_details')
                      .insert([
                        { invoice_id: return_invoice_id, invoice_date: return_trip_date, inventory_unit: return_load_unit, trip_id: return_trip_id, customer_gstnumber: return_buyer_gst, man_gstnumber: suppliergst, customer_id: return_buyer_id, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: return_buyer, customer_address: return_buyer_address, customer_deliveryaddress: return_buyer_address, man_name: supplier_name, man_address: supplier_address, transport_distance: return_transport_distance, transport_charges: return_transport_charges, inventory_costperunit: return_costperunit, inventory_quantity: return_load, inventory_type: return_inventory, inventory_cost: (parseInt(return_costperunit) * parseInt(return_load)), total_cost: ((parseInt(return_costperunit) * parseInt(return_load)) + ((parseInt(return_costperunit) * parseInt(return_load)) * 18) / 100), payment_type: return_payment_by, paid_at: return_paid_at, transaction_id: return_transaction_id, payment_status: return_payment_status },
                      ])
                    if (return_invoice_detail !== null && return_invoice_detail.length > 0) {
                      toast.success(`Trip Created Successfully`)
                      setLarge(!Large)
                      getTripDetail()
                    } else {
                      toast.error(`Error in Creating Trip`)
                      await supabase
                        .from('trip_details')
                        .delete()
                        .eq('trip_id', trip_id)
                      await supabase
                        .from('trip_details')
                        .delete()
                        .eq('trip_id', return_trip_id)
                      await supabase
                        .from('invoice_details')
                        .delete()
                        .eq('invoice_id', invoice_id)

                    }

                  } else {
                    toast.success(`Trip Created Successfully`)
                    setLarge(!Large)
                    getTripDetail()
                  }
                } else {
                  toast.error(`Error in Creating Trip`)
                  await supabase
                    .from('trip_details')
                    .delete()
                    .eq('trip_id', trip_id)
                  await supabase
                    .from('trip_details')
                    .delete()
                    .eq('trip_id', return_trip_id)
                }
              } else {
                toast.error(`Error in Creating Trip`)
                await supabase
                  .from('trip_details')
                  .delete()
                  .eq('trip_id', trip_id)
              }
            } else {
              const { data: invoice_detail, error1 } = await supabase
                .from('invoice_details')
                .insert([
                  { invoice_id: invoice_id, invoice_date: trip_date, inventory_unit: inventory_unit, trip_id: trip_id, customer_gstnumber: buyergst, man_gstnumber: suppliergst, customer_id: buyer_id, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: buyer_name, customer_address: buyer_address, customer_deliveryaddress: buyer_address, man_name: supplier_name, man_address: supplier_address, transport_distance: transport_distance, transport_charges: transport_charges, inventory_costperunit: inventory_costperunit, inventory_quantity: inventory_quantity, inventory_type: inventory_type, inventory_cost: (parseInt(inventory_costperunit) * parseInt(inventory_quantity)), total_cost: ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) + ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) * 18) / 100), payment_type: payment_by, paid_at: paid_at, transaction_id: transaction_id, payment_status: payment_status },
                ])

              if (invoice_detail !== null && invoice_detail.length > 0) {
                toast.success(`Trip Created Successfully`)
              } else {
                toast.error(`Error in Creating Trip`)
                await supabase
                  .from('trip_details')
                  .delete()
                  .eq('trip_id', trip_id)
              }

            }


          } else {
            toast.error(error.message)
          }

        }
      }
    } else {
      if (trip_date === "") {
        toast.error("Please Select Trip Date")
      } else if (inventory_id === "") {
        toast.error("Please Select Inventory")
      } else if (inventory_quantity === "") {
        toast.error("Please Enter Inventory Quantity")
      } else if (inventory_quantity > inventory_totalquantity) {
        toast.error(`Inventory Quantity not more than ${inventory_totalquantity}`)
      } else if (driver_id === "") {
        toast.error("Please Select Driver")
      } else if (vehicle_id === "") {
        toast.error("Please Select Vehicle")
      } else if (buyer_id === "") {
        toast.error("Please Select Buyer")
      } else if (tonnage_buyer === "") {
        toast.error("Please Enter Buyer Tonnage")
      } else if (tonnage_supplier === "") {
        toast.error("Please Enter Supplier Tonnage")
      } else if (trip_amount === "") {
        toast.error("Please Enter Trip Amount")
      } else if (transport_distance === "") {
        toast.error("Please Enter Transport Distance")


      } else if (transport_charges === "") {
        toast.error("Please Enter Transport Charges")
      } else if (delivery_status === "") {
        toast.error("Please Select Delivery Status")
      } else if (payment_status === "") {
        toast.error("Please Select Payment Status")
      } else {
        var tripid = id
        if (inventory_mainquantity !== inventory_quantity) {
          await supabase
            .from('inventory_details')
            .update(
              { inventory_quantity: (parseInt(inventory_totalquantity) - (parseInt(inventory_quantity) - parseInt(inventory_mainquantity))), inventory_sold: (parseInt(inventory_sold) + (parseInt(inventory_quantity) - parseInt(inventory_mainquantity))) },
            )
            .eq('inventory_id', inventory_id)
        }

        const { data, error } = await supabase
          .from('trip_details')
          .update([
            { customer_id: buyer_id, createdBy: window.localStorage.getItem("useremail"), supplier_coordinate: supplier_coordinate, man_id: supplier_id, customer_name: buyer_name, customer_address: buyer_address, customer_deliveryaddress: buyer_address, man_name: supplier_name, man_address: supplier_address, vehicle_id: vehicle_id, driverid: driver_id, vehicle_number: vehicle_number, driver_name: driver_name, inventory_id: inventory_id, inventory_quantity: inventory_quantity, transport_distance: transport_distance, transport_charges: transport_charges, inventory_type: inventory_type, tonnage_man: tonnage_supplier, tonnage_customer: tonnage_buyer, tonnage_vehicle: vehicle_tonnage, invoice_id: invoice_id, payment_by: payment_by, paid_at: paid_at, transaction_id: transaction_id, delivery_status: delivery_status, payment_status: payment_status, trip_date: trip_date, trip_amount: trip_amount }
          ])
          .eq('trip_id', tripid)

        if (data !== null) {
          const { data: invoice_detail, error1 } = await supabase
            .from('invoice_details')
            .update([
              { invoice_date: trip_date, inventory_unit: inventory_unit, trip_id: trip_id, customer_gstnumber: buyergst, man_gstnumber: suppliergst, customer_id: buyer_id, createdBy: window.localStorage.getItem("useremail"), man_id: supplier_id, customer_name: buyer_name, customer_address: buyer_address, customer_deliveryaddress: buyer_address, man_name: supplier_name, man_address: supplier_address, transport_distance: transport_distance, transport_charges: transport_charges, inventory_costperunit: inventory_costperunit, inventory_quantity: inventory_quantity, inventory_type: inventory_type, inventory_cost: (parseInt(inventory_costperunit) * parseInt(inventory_quantity)), total_cost: ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) + ((parseInt(inventory_costperunit) * parseInt(inventory_quantity)) * 18) / 100), payment_type: payment_by, paid_at: paid_at, transaction_id: transaction_id, payment_status: payment_status },
            ])
            .eq('invoice_id', data[0].invoice_id)

          if (invoice_detail !== null) {
            toast.success(`Trip Updated Successfully`)
            setLarge(!Large)
            getTripDetail()
          } else {
            toast.error(error1.message)

          }


        } else {
          toast.error(error.message)
        }


      }

    }
  }
  function updateBuyerdetail(data) {
    if (data !== "") {
      var data = buyer_detail.filter((e) => {
        return (
          e.customer_id === data
        )
      })


      setbuyer_address(data[0].customer_address)

      setbuyer_name(data[0].customer_name)

      setbuyer_id(data[0].customer_id)
      setbuyergst(data[0].customer_gstnumber)
    } else {
      setbuyer_address("")

      setbuyer_name("")

      setbuyer_id("")
      setbuyergst("")
    }
  }
  function updatereturnBuyerdetail(data) {
    if (data !== "") {
      var data = buyer_detail.filter((e) => {
        return (
          e.customer_id === data
        )
      })


      setreturn_buyer_address(data[0].customer_address)

      setreturn_buyer(data[0].customer_name)

      setreturn_buyer_id(data[0].customer_id)
      setreturn_buyer_gst(data[0].customer_gstnumber)
    } else {
      setreturn_buyer("")

      setreturn_buyer_id("")
      setreturn_buyer_gst("")
      setreturn_buyer_address("")
    }
  }
  function updateInventorydetail(data) {
    if (data !== "") {

      var inventory = Inventory_detail.filter((e) => {
        return (
          e.inventory_id === data
        )
      })



      setinventory_type(inventory[0].inventory_type)
      setinventory_id(inventory[0].inventory_id)
      setinventory_costperunit(inventory[0].inventory_costperunit)
      setinventory_unit(inventory[0].inventory_units)
      setinventory_totalquantity(inventory[0].inventory_quantity)
      setinventory_sold(inventory[0].inventory_sold)
    } else {
      setinventory_type("")
      setinventory_id("")
      setinventory_costperunit("")
      setinventory_unit("")
      setinventory_totalquantity("")
      setinventory_sold("")
    }


  }
  function updatereturnInventorydetail(data) {

    if (data !== "") {
      var inventory = Inventory_detail.filter((e) => {
        return (
          e.inventory_id === data
        )
      })



      setreturn_inventory(inventory[0].inventory_type)
      setreturn_inventory_id(inventory[0].inventory_id)
      setreturn_costperunit(inventory[0].inventory_costperunit)
      setreturn_load_unit(inventory[0].inventory_units)
      setreturn_load_total_quantity(inventory[0].inventory_quantity)
      setreturn_load_sold(inventory[0].inventory_sold)
    } else {
      setreturn_inventory("")
      setreturn_inventory_id("")
      setreturn_costperunit("")
      setreturn_load_unit("")
      setreturn_load_total_quantity("")
      setreturn_load_sold("")

    }


  }
  function updateDriverdetail(data) {
    if (data !== "") {
      var data = Driver_detail.filter((e) => {
        return (
          e.driver_id === data
        )
      })
      setdriver_id(data[0].driver_id)

      setdriver_name(data[0].driver_name)
    } else {
      setdriver_id("")

      setdriver_name("")
    }


  }
  function updatereturnDriverdetail(data) {
    if (data !== "") {
      var data = Driver_detail.filter((e) => {
        return (
          e.driver_id === data
        )
      })
      setreturn_driver_id(data[0].driver_id)

      setreturn_driver_name(data[0].driver_name)
    } else {
      setdriver_id("")

      setdriver_name("")
    }


  }
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  function convertdata(tripdate) {
    var date = new Date(tripdate)
    var day_date = date.getDate()
    var month = date.getMonth()
    var day = date.getDay()


    var newdate = dayNames[day] + "-" + day_date + "-" + monthNames[month]
    return newdate
  }
  function updatevehicledetail(data) {



    var data = vehicle_detail.filter((e) => {
      return (
        e.vehicle_id === data
      )
    })

    setvehicle_id(data[0].vehicle_id)
    setvehicle_tonnage(data[0].vehicle_tonnage)
    setvehicle_number(data[0].vehicle_number)

    setvehicle_type(data[0].vehicle_type)



  }
  function updatereturnvehicledetail(data) {



    var data = vehicle_detail.filter((e) => {
      return (
        e.vehicle_id === data
      )
    })

    setreturn_vehicle_id(data[0].vehicle_id)
    setreturn_vehicle_tonnage(data[0].vehicle_tonnage)
    setreturn_vehicle_number(data[0].vehicle_number)

    setreturn_vehicle_type(data[0].vehicle_type)



  }
  async function gettripfilterdata(data, type) {

    if (type === "date") {
      settabbuyerid("")

      settabvehicleid("")
      settabdriverid("")
      settabpayment("")
      setabdelivery("")

      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("trip_date", data)
        .order('id', { ascending: false })

      if (trip_Details !== null && trip_Details.length > 0) {
        settrip_detail(trip_Details)
      } else {
        // toast.error("No Buyer Details Found")
        settrip_detail([])

      }
    } else if (type === "vehicle") {
      settabbuyerid("")
      settabtripdate("")

      settabdriverid("")
      settabpayment("")
      setabdelivery("")

      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("vehicle_id", data)
        .order('id', { ascending: false })

      if (trip_Details !== null && trip_Details.length > 0) {
        settrip_detail(trip_Details)
      } else {
        // toast.error("No Buyer Details Found")
        settrip_detail([])

      }
    } else if (type === "driver") {
      settabbuyerid("")
      settabtripdate("")
      settabvehicleid("")

      settabpayment("")
      setabdelivery("")

      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("driverid", data)
        .order('id', { ascending: false })

      if (trip_Details !== null && trip_Details.length > 0) {
        settrip_detail(trip_Details)
      } else {
        // toast.error("No Buyer Details Found")
        settrip_detail([])

      }
    } else if (type === "buyer") {

      settabtripdate("")
      settabvehicleid("")
      settabdriverid("")
      settabpayment("")
      setabdelivery("")

      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("customer_id", data)
        .order('id', { ascending: false })

      if (trip_Details !== null && trip_Details.length > 0) {
        settrip_detail(trip_Details)
      } else {
        // toast.error("No Buyer Details Found")
        settrip_detail([])

      }

    } else if (type === "delivery") {
      settabbuyerid("")
      settabtripdate("")
      settabvehicleid("")
      settabdriverid("")
      settabpayment("")


      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("delivery_status", data)
        .order('id', { ascending: false })

      if (trip_Details !== null && trip_Details.length > 0) {
        settrip_detail(trip_Details)
      } else {
        // toast.error("No Buyer Details Found")
        settrip_detail([])

      }
    } else {
      settabbuyerid("")
      settabtripdate("")
      settabvehicleid("")
      settabdriverid("")

      setabdelivery("")

      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("payment_status", data)
        .order('id', { ascending: false })

      if (trip_Details !== null && trip_Details.length > 0) {



        settrip_detail(trip_Details)

      } else {
        // toast.error("No Buyer Details Found")
        settrip_detail([])

      }
    }



  }
  function downloadpdf() {
    const downloadSection = document.getElementById('trip_table');




    html2canvas(downloadSection).then(function (
      canvas
    ) {
      var cWidth = canvas.width;
      var cHeight = canvas.height;
      var topLeftMargin = 0;
      var pdfWidth = cWidth + topLeftMargin * 2;
      var pdfHeight = pdfWidth * 1.5 + topLeftMargin * 2;
      var canvasImageWidth = cWidth;
      var canvasImageHeight = cHeight;
      var totalPDFPages = Math.ceil(cHeight / pdfHeight) - 1;
      canvas.getContext('2d');
      var imgData = canvas.toDataURL('image/png', 1.0);
      var pdf = new jsPDF('p', 'pt', [pdfWidth, pdfHeight]);
      pdf.addImage(
        imgData,
        'PNG',
        topLeftMargin,
        topLeftMargin,
        canvasImageWidth,
        canvasImageHeight
      );
      for (var i = 1; i <= totalPDFPages; i++) {
        pdf.addPage(pdfWidth, pdfHeight);
        pdf.addImage(
          imgData,
          'PNG',
          topLeftMargin,
          -(pdfHeight * i) + topLeftMargin * 0,
          canvasImageWidth,
          canvasImageHeight
        );
      }
      pdf.save('Trip_details.pdf');
    });
  }
  function updatereturnstatus() {
    if (return_trip_status === true) {
      setreturn_trip_status(false)
      settrip_type([{
        trip_name: "One Way Trip"
      }])
    } else {
      settrip_type([{
        trip_name: "One Way Trip"
      }, {
        trip_name: "Return Trip",
      }])
      setreturn_trip_status(true)
    }


  }
  const closeCustomizer = () => {
    setRightSidebar(!rightSidebar)
    document.querySelector(".customizer-contain").classList.remove('open');

  }



  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Trip Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12" id="maintrip" style={window.innerWidth < 800 ? { paddingLeft: '5px', paddingRight: "5px" } : { width: "100%" }}>
            <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
              <ModalHeader toggle={LargeModaltoggle}>
                {edittype === "new" ? "Create" : "Update"} Here For Trip
                {edittype === "new" ? <>
                  <Table className='table-borderless'>
                    <tbody>
                      <tr style={{ display: "flex", alignItems: "center" }}>
                        {trip_type.length > 0 && trip_type.map((item, index) => {
                          return (

                            <td style={{ verticalAlign: "inherit" }} key={index}>

                              <button className="btn " style={{ backgroundColor: index === trip_status ? "#E50014" : "whitesmoke", color: index !== trip_status ? "black" : "white", borderRadius: "5px" }} onClick={() => { getTripDetail(); settrip_status(index) }}>{item.trip_name}</button>
                            </td>
                          )
                        })}


                      </tr>
                    </tbody>
                  </Table>
                  <Row>

                    <Col>
                      <FormGroup className="custom-radio-ml">
                        <div className="checkbox">
                          <Input id="checkbox1" type="checkbox" checked={return_trip_status} onChange={(e) => { updatereturnstatus() }} />
                          <Label for="checkbox1">Return Trip</Label>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </> : ""}
              </ModalHeader>
              <ModalBody>
                <Row>
                  {edittype === "new" ? <>
                    {trip_status === 0 ?
                      <Col>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Trip Date<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="date" placeholder="Enter Trip date" value={trip_date} onChange={(e) => { settrip_date(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Inventory Type<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">

                            <Input className="form-control" type="select" value={inventory_id} onChange={(e) => {
                              updateInventorydetail(e.target.value)

                              setinventory_id(e.target.value)



                            }}>
                              <option value={""}>Choose Inventory Type</option>
                              {Inventory_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.inventory_id} >{data.inventory_type}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Inventory Quantity<span style={{ color: "#E50014" }}>*</span></Label>
                          {inventory_unit === "" ? <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Inventory Quantity" value={inventory_quantity} onChange={(e) => { setinventory_quantity(e.target.value); settrip_amount(parseInt(inventory_costperunit) * parseInt(e.target.value)) }} />
                          </Col> :
                            <>
                              <Col sm="10">
                                <Input className="form-control" type="number" placeholder="Enter Inventory Quantity" value={inventory_quantity} onChange={(e) => { setinventory_quantity(e.target.value); settrip_amount(parseInt(inventory_costperunit) * parseInt(e.target.value)) }} />
                              </Col>
                              <Col sm="2">
                                <span className="input-group-text" style={{ backgroundColor: "#fff", border: "1px solid #ced4da", color: "#E50014", justifyContent: "center" }}>{inventory_unit}</span>
                              </Col></>}
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Driver Name<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">

                            <Input className="form-control" type="select" value={driver_id} onChange={(e) => {
                              updateDriverdetail(e.target.value)
                              setdriver_id(e.target.value)
                            }}>
                              <option value={""}>Choose Driver</option>
                              {Driver_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.driver_id}>{data.driver_name}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Vehicle Number <span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">

                            <Input className="form-control" type="select" value={vehicle_id} onChange={(e) => {
                              updatevehicledetail(e.target.value)
                              setvehicle_id(e.target.value)
                            }}>
                              <option value={""}>Choose Vehicle Number</option>
                              {vehicle_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.vehicle_id}>{data.vehicle_number}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>

                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Buyer Name<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">

                            <Input className="form-control" type="select" value={buyer_id} onChange={(e) => {
                              updateBuyerdetail(e.target.value)
                              setbuyer_id(e.target.value)
                            }}>
                              <option value={""}>Choose Buyer Name</option>
                              {buyer_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.customer_id}>{data.customer_name}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>
                        {/* <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Buyer Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Buyer Tonnage" value={tonnage_buyer} onChange={(e) => { settonnage_buyer(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Supplier Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Supplier Tonnage" value={tonnage_supplier} onChange={(e) => { settonnage_supplier(e.target.value) }} />
                          </Col>
                        </FormGroup> */}
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Trip Amount<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Trip Amount" value={trip_amount} onChange={(e) => { settrip_amount(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Transport Distance<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="10">
                            <Input className="form-control" type="number" placeholder="Enter Transport Distance" value={transport_distance} onChange={(e) => { settransport_distance(e.target.value); settransport_charges(parseInt(e.target.value) * 45) }} />
                          </Col>
                          <Col sm="2">
                            <span className="input-group-text" style={{ backgroundColor: "#fff", border: "1px solid #ced4da", color: "#E50014", justifyContent: "center" }}>{"Km"}</span>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Transport Charges<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Transport Charges" value={transport_charges} onChange={(e) => { settransport_charges(e.target.value) }} />
                          </Col>
                        </FormGroup>

                        {/* <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Transaction Id<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="text" placeholder="Enter Transaction Id" value={transaction_id} onChange={(e) => { settransaction_id(e.target.value) }} />
                          </Col>
                        </FormGroup> */}
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Payment By<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" placeholder="Choose Payment By" value={payment_by} onChange={(e) => { setpayment_by(e.target.value) }} >
                              <option value={""}>Choose Payment By</option>
                              <option value={"Card"}>Card</option>
                              <option value={"Cash"}>Cash</option>
                              <option value={"UPI"}>UPI</option>
                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Paid At<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="datetime-local" placeholder="Enter Paid At" value={paid_at} onChange={(e) => { setpaid_at(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Delivery Status<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" placeholder="Enter Delivered At" value={delivery_status} onChange={(e) => { setdelivery_status(e.target.value) }} >
                              <option value={""}>Choose Delivery Status</option>
                              <option value={"Delivered"}>Delivered</option>
                              <option value={"IN-TRANSIT"}>IN-TRANSIT</option>

                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Payment Status<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" placeholder="Choose Payment By" value={payment_status} onChange={(e) => { setpayment_status(e.target.value) }} >
                              <option value={""}>Choose Payment Status</option>
                              <option value={"Paid"}>Paid</option>
                              <option value={"Pending"}>Pending</option>

                            </Input>
                          </Col>
                        </FormGroup>



                        <FormGroup className="mb-0 mt-3">


                          {return_trip_status === true ? <Button color="primary" className="btn-block" onClick={() => {
                            settrip_status(1);
                          }}>Next </Button> : <Button color="primary" className="btn-block" onClick={() => {
                            RegisterUser(edittype, editid)
                          }}>PROCEED </Button>}
                        </FormGroup>






                      </Col> :
                      <Col>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Trip Date<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="date" placeholder="Enter Trip date" value={return_trip_date} onChange={(e) => { setreturn_trip_date(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Inventory<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" placeholder="Enter Return Inventory" value={return_inventory_id} onChange={(e) => { updatereturnInventorydetail(e.target.value); setreturn_inventory_id(e.target.value) }} >
                              <option value={""}>Choose Return Inventory</option>
                              {Inventory_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.inventory_id} >{data.inventory_type}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Inventory Quantity<span style={{ color: "#E50014" }}>*</span></Label>
                          {return_load_unit === "" ? <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Return Load" value={return_load} onChange={(e) => { setreturn_load(e.target.value); set_return_amount(parseInt(return_costperunit) * parseInt(e.target.value)) }} />
                          </Col> : <>
                            <Col sm="10">
                              <Input className="form-control" type="number" placeholder="Enter Return Load" value={return_load} onChange={(e) => { setreturn_load(e.target.value); set_return_amount(parseInt(return_costperunit) * parseInt(e.target.value)) }} />
                            </Col>
                            <Col sm="2">
                              <span className="input-group-text" style={{ backgroundColor: "#fff", border: "1px solid #ced4da", color: "#E50014", justifyContent: "center" }}>{return_load_unit}</span>
                            </Col></>}
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Driver Name<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">

                            <Input className="form-control" type="select" value={return_driver_id} onChange={(e) => {
                              updatereturnDriverdetail(e.target.value)
                              setreturn_driver_id(e.target.value)
                            }}>
                              <option value={""}>Choose Driver</option>
                              {Driver_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.driver_id}>{data.driver_name}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Vehicle Number <span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">

                            <Input className="form-control" type="select" value={return_vehicle_id} onChange={(e) => {
                              updatereturnvehicledetail(e.target.value)
                              setreturn_vehicle_id(e.target.value)
                            }}>
                              <option value={""}>Choose Vehicle Number</option>
                              {vehicle_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.vehicle_id}>{data.vehicle_number}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>

                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Buyer<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">

                            <Input className="form-control" type="select" value={return_buyer_id} onChange={(e) => {
                              updatereturnBuyerdetail(e.target.value)

                              setreturn_buyer_id(e.target.value)
                            }}>
                              <option value={""}>Choose Return Buyer</option>
                              {buyer_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.customer_id}>{data.customer_name}</option>
                                )
                              })}
                            </Input>
                          </Col>
                        </FormGroup>
                        {/* <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Buyer Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Buyer Tonnage" value={return_tonnage_buyer} onChange={(e) => { setreturn_tonnage_buyer(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Supplier Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Supplier Tonnage" value={return_tonnage_supplier} onChange={(e) => { setreturn_tonnage_supplier(e.target.value) }} />
                          </Col>
                        </FormGroup> */}

                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Trip Amount<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Return Trip Amount" value={return_trip_amount} onChange={(e) => { set_return_amount(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Transport Distance<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="10">
                            <Input className="form-control" type="number" placeholder="Enter Transport Distance" value={return_transport_distance} onChange={(e) => { setreturn_transport_distance(e.target.value); setreturn_transport_charges(parseInt(e.target.value) * 45) }} />
                          </Col>
                          <Col sm="2">
                            <span className="input-group-text" style={{ backgroundColor: "#fff", border: "1px solid #ced4da", color: "#E50014", justifyContent: "center" }}>{"Km"}</span>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Return Transport Charges<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="number" placeholder="Enter Transport Charges" value={return_transport_charges} onChange={(e) => { setreturn_transport_charges(e.target.value) }} />
                          </Col>
                        </FormGroup>

                        {/* <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Transaction Id<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="text" placeholder="Enter Transaction Id" value={return_transaction_id} onChange={(e) => { setreturn_transaction_id(e.target.value) }} />
                          </Col>
                        </FormGroup> */}
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Payment By<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" placeholder="Choose Payment By" value={return_payment_by} onChange={(e) => { setreturn_payment_by(e.target.value) }} >
                              <option value={""}>Choose Payment By</option>
                              <option value={"Card"}>Card</option>
                              <option value={"Cash"}>Cash</option>
                              <option value={"UPI"}>UPI</option>
                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Paid At<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="datetime-local" placeholder="Enter Paid At" value={return_paid_at} onChange={(e) => { setreturn_paid_at(e.target.value) }} />
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Delivery Status<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" placeholder="Enter Delivered At" value={return_delivery_status} onChange={(e) => { setreturn_delivery_status(e.target.value) }} >
                              <option value={""}>Choose Delivery Status</option>
                              <option value={"Delivered"}>Delivered</option>
                              <option value={"IN-TRANSIT"}>IN-TRANSIT</option>

                            </Input>
                          </Col>
                        </FormGroup>
                        <FormGroup className="row">
                          <Label className="col-sm-12 col-form-label">Payment Status<span style={{ color: "#E50014" }}>*</span></Label>
                          <Col sm="12">
                            <Input className="form-control" type="select" placeholder="Choose Payment By" value={return_payment_status} onChange={(e) => { setreturn_payment_status(e.target.value) }} >
                              <option value={""}>Choose Payment Status</option>
                              <option value={"Paid"}>Paid</option>
                              <option value={"Pending"}>Pending</option>

                            </Input>
                          </Col>
                        </FormGroup>









                        <FormGroup className="mb-0 mt-3">


                          <Button color="primary" className="btn-block" onClick={() => {
                            RegisterUser(edittype, editid)
                          }}>PROCEED </Button>
                        </FormGroup>






                      </Col>}</> : <Col>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Trip Date<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="date" placeholder="Enter Trip date" value={trip_date} onChange={(e) => { settrip_date(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Inventory Type<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <Input className="form-control" type="select" value={inventory_id} onChange={(e) => {
                          updateInventorydetail(e.target.value)

                          setinventory_id(e.target.value)



                        }}>
                          <option value={""}>Choose Inventory Type</option>
                          {Inventory_detail.map((data, i) => {

                            return (
                              <option key={i} value={data.inventory_id} >{data.inventory_type}</option>
                            )
                          })}
                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Inventory Quantity<span style={{ color: "#E50014" }}>*</span></Label>
                      {inventory_unit === "" ? <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Inventory Quantity" value={inventory_quantity} onChange={(e) => { setinventory_quantity(e.target.value); settrip_amount(parseInt(inventory_costperunit) * parseInt(e.target.value)) }} />
                      </Col> :
                        <>
                          <Col sm="10">
                            <Input className="form-control" type="number" placeholder="Enter Inventory Quantity" value={inventory_quantity} onChange={(e) => { setinventory_quantity(e.target.value); settrip_amount(parseInt(inventory_costperunit) * parseInt(e.target.value)) }} />
                          </Col>
                          <Col sm="2">
                            <span className="input-group-text" style={{ backgroundColor: "#fff", border: "1px solid #ced4da", color: "#E50014", justifyContent: "center" }}>{inventory_unit}</span>
                          </Col></>}
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Driver Name<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <Input className="form-control" type="select" value={driver_id} onChange={(e) => {
                          updateDriverdetail(e.target.value)
                          setdriver_id(e.target.value)
                        }}>
                          <option value={""}>Choose Driver</option>
                          {Driver_detail.map((data, i) => {

                            return (
                              <option key={i} value={data.driver_id}>{data.driver_name}</option>
                            )
                          })}
                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Vehicle Number <span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <Input className="form-control" type="select" value={vehicle_id} onChange={(e) => {
                          updatevehicledetail(e.target.value)
                          setvehicle_id(e.target.value)
                        }}>
                          <option value={""}>Choose Vehicle Number</option>
                          {vehicle_detail.map((data, i) => {

                            return (
                              <option key={i} value={data.vehicle_id}>{data.vehicle_number}</option>
                            )
                          })}
                        </Input>
                      </Col>
                    </FormGroup>

                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Buyer Name<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">

                        <Input className="form-control" type="select" value={buyer_id} onChange={(e) => {
                          updateBuyerdetail(e.target.value)
                          setbuyer_id(e.target.value)
                        }}>
                          <option value={""}>Choose Buyer Name</option>
                          {buyer_detail.map((data, i) => {

                            return (
                              <option key={i} value={data.customer_id}>{data.customer_name}</option>
                            )
                          })}
                        </Input>
                      </Col>
                    </FormGroup>
                    {/* <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Buyer Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Buyer Tonnage" value={tonnage_buyer} onChange={(e) => { settonnage_buyer(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Supplier Tonnage<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Supplier Tonnage" value={tonnage_supplier} onChange={(e) => { settonnage_supplier(e.target.value) }} />
                      </Col>
                    </FormGroup> */}
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Trip Amount<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Trip Amount" value={trip_amount} onChange={(e) => { settrip_amount(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Transport Distance<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="10">
                        <Input className="form-control" type="number" placeholder="Enter Transport Distance" value={transport_distance} onChange={(e) => { settransport_distance(e.target.value); settransport_charges(parseInt(e.target.value) * 45) }} />
                      </Col>
                      <Col sm="2">
                        <span className="input-group-text" style={{ backgroundColor: "#fff", border: "1px solid #ced4da", color: "#E50014", justifyContent: "center" }}>{"Km"}</span>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Transport Charges<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="number" placeholder="Enter Transport Charges" value={transport_charges} onChange={(e) => { settransport_charges(e.target.value) }} />
                      </Col>
                    </FormGroup>

                    {/* <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Transaction Id<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="text" placeholder="Enter Transaction Id" value={transaction_id} onChange={(e) => { settransaction_id(e.target.value) }} />
                      </Col>
                    </FormGroup> */}
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Payment By<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="select" placeholder="Choose Payment By" value={payment_by} onChange={(e) => { setpayment_by(e.target.value) }} >
                          <option value={""}>Choose Payment By</option>
                          <option value={"Card"}>Card</option>
                          <option value={"Cash"}>Cash</option>
                          <option value={"UPI"}>UPI</option>
                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Paid At<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="datetime-local" placeholder="Enter Paid At" value={paid_at} onChange={(e) => { setpaid_at(e.target.value) }} />
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Delivery Status<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="select" placeholder="Enter Delivered At" value={delivery_status} onChange={(e) => { setdelivery_status(e.target.value) }} >
                          <option value={""}>Choose Delivery Status</option>
                          <option value={"Delivered"}>Delivered</option>
                          <option value={"IN-TRANSIT"}>IN-TRANSIT</option>

                        </Input>
                      </Col>
                    </FormGroup>
                    <FormGroup className="row">
                      <Label className="col-sm-12 col-form-label">Payment Status<span style={{ color: "#E50014" }}>*</span></Label>
                      <Col sm="12">
                        <Input className="form-control" type="select" placeholder="Choose Payment By" value={payment_status} onChange={(e) => { setpayment_status(e.target.value) }} >
                          <option value={""}>Choose Payment Status</option>
                          <option value={"Paid"}>Paid</option>
                          <option value={"Pending"}>Pending</option>

                        </Input>
                      </Col>
                    </FormGroup>



                    <FormGroup className="mb-0 mt-3">


                      <Button color="primary" className="btn-block" onClick={() => {
                        RegisterUser(edittype, editid)
                      }}>PROCEED </Button>
                    </FormGroup>






                  </Col>}
                </Row>
              </ModalBody>
            </Modal>
            <div className="customizer-contain" style={{ zIndex: "11" }}>
              <div className="tab-content" id="c-pills-tabContent">
                <div className="customizer-header">
                  <i className="icon-close" onClick={closeCustomizer}></i>
                  <h5>{t("filter")}</h5>



                </div>
                <div className="customizer-body custom-scrollbar">
                  <TabContent activeTab={activeTab1}>
                    <TabPane tabId="1">
                      <Row>
                        <Col sm="12" style={{ display: "flex", justifyContent: "end", margin: "10px" }}>
                          <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer", backgroundColor: "#e8e8e8", padding: "5px 10px", borderRadius: "20px" }} onClick={() => {
                            getTripDetail();
                          }}>{t("Clear")}</div>

                        </Col>
                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="exampledate">{t("Trip Date")}</Label>

                          <div style={{ textAlign: "center" }}>
                            <Input type="date" value={tabtripdate} onChange={(e) => { gettripfilterdata(e.target.value, "date"); settabtripdate(e.target.value) }} />
                          </div>
                        </Col>

                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="examplestatus">{t("Vehicle ")}</Label>
                          <div style={{ textAlign: "center" }}>
                            <Input className="form-control" type="select" value={tabvehicleid} onChange={(e) => {
                              settabvehicleid(e.target.value)
                              gettripfilterdata(e.target.value, "vehicle")
                            }}>
                              <option value={""}>Vehicle</option>
                              {vehicle_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.vehicle_id}>{data.vehicle_number}</option>
                                )
                              })}
                            </Input></div>
                        </Col>
                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="examplestatus">{t("Driver")}</Label>
                          <div style={{ textAlign: "center" }}>
                            <Input className="form-control" type="select" value={tabdriverid} onChange={(e) => {
                              settabdriverid(e.target.value)
                              gettripfilterdata(e.target.value, "driver")
                            }}>
                              <option value={""}>Driver</option>
                              {Driver_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.driver_id}>{data.driver_name}</option>
                                )
                              })}
                            </Input></div>
                        </Col>
                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="examplestatus">{t("Buyer")}</Label>
                          <div style={{ textAlign: "center" }}>
                            <Input className="form-control" type="select" value={tabbuyerid} onChange={(e) => {
                              settabbuyerid(e.target.value)
                              gettripfilterdata(e.target.value, "buyer")
                            }}>
                              <option value={""}>Buyer</option>
                              {buyer_detail.map((data, i) => {

                                return (
                                  <option key={i} value={data.customer_id}>{data.customer_name}</option>
                                )
                              })}
                            </Input></div>


                        </Col>




                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="examplestatus">{t("Delivery Status")}</Label>

                          <div style={{ textAlign: "center" }}>
                            <Input className="form-control" type="select" placeholder="Enter Delivered At" value={tabdelivery} onChange={(e) => { gettripfilterdata(e.target.value, "delivery"); setabdelivery(e.target.value) }} >
                              <option value={""}>{t("Delivery")} </option>
                              <option value={"Delivered"}>{t("Delivered")}</option>
                              <option value={"IN-TRANSIT"}>{t("IN-TRANSIT")}</option>

                            </Input></div>
                        </Col>
                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="examplestatus">{t("Payment Status")}</Label>

                          <div style={{ textAlign: "center" }}>
                            <Input className="form-control" type="select" placeholder="Choose Payment By" value={tabpayment} onChange={(e) => { gettripfilterdata(e.target.value, "payment"); settabpayment(e.target.value) }} >
                              <option value={""}>Payment</option>
                              <option value={"Paid"}>Paid</option>
                              <option value={"Pending"}>Pending</option>

                            </Input>
                          </div>
                        </Col>

                        <Col sm="12" style={{ display: "flex", justifyContent: "center", margin: "10px" }}>

                          <div style={{ textAlign: "center" }}>
                            <button className="btn " style={{ backgroundColor: "black", color: "white", borderRadius: "5px" }} onClick={() => { closeCustomizer(); }}>{t("Show Result")} {tabdelivery !== "" || tabtripdate !== "" || tabbuyerid !== "" || tabdriverid !== "" || tabvehicleid !== "" || tabpayment !== "" ? parseInt(trip_detail.length) : ""}</button>
                          </div>


                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>


            {window.innerWidth < 800 ? <>
              {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row", margin: "10px" }}> */}
              <div onClick={() => { openCustomizer('1') }} style={{ display: "flex", alignItems: "center", cursor: "pointer", position: "absolute", top: "-44px", right: "20px" }}>
                <Icon icon="bx:filter" color="black" width="35" height="35" />
              </div>
              <button className='btn' style={{ zIndex: "10", fontSize: "16px", padding: "15px", boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)", float: "right", position: "fixed", bottom: "130px", right: "30px", borderRadius: "20px", backgroundColor: "#E50014", color: "white" }} onClick={() => {
                LargeModaltoggle(); setedittype("new")
                seteditid(""); setreturn_trip_status(false); updatereturnstatus(); settrip_status(0)
              }}><i className="fa fa-plus "></i> &nbsp;Create Trip</button>
              {/* </div> */}
              {/* <div className="mainopShadow"></div>
              <div className="fab">
                <div className="mainop">
                  <i  className=" fa fa-plus"></i> <span>Create Trip</span>
                </div>

              </div> */}

              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll", padding: '5px' } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">

                    {trip_detail.length > 0 ? <>
                      {trip_detail.map((data, i) => {
                        return (
                          <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                            <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                              <h5 className="mb-0" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>
                                      <div className="media-size-email"> <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px 15px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div>
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Trip To</span>
                                        <span style={{ display: "block" }}>{data.customer_name}</span>
                                        <span style={{ display: "block" }}>{data.customer_address}</span>
                                       

                                      </div>


                                    </div>
                                  </div>



                                </Accordion.Toggle>
                                <div className="media-size-email" style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#dfffe4", padding: "5px", cursor: "pointer" }} onClick={() => {
                                  UpdateUser(data.trip_id)
                                }}><Icon icon="bxs:edit" color="darkgreen" width="30" height="30" /></div>
                                  &nbsp;
                                  <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#efc6ca", padding: "5px", cursor: "pointer" }} onClick={() => {
                                    DeleteUser(data.trip_id)
                                  }}><Icon icon="bi:trash" color="#E50014" width="25" height="25" /></div>



                                </div>
                              </h5>
                            </CardHeader>
                            <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                              <CardBody>
                                <div className="email-app-sidebar left-bookmark">
                                  <div className="media" style={{ alignItems: "center " }}>

                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle</span>
                                      <span style={{ display: "block" }}>{data.vehicle_number}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Stock</span>
                                      <span style={{ display: "block" }}>{data.inventory_type}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Distance</span>
                                      <span style={{ display: "block" }}>{data.transport_distance} Km</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Payment Status</span>
                                      <span style={{ display: "block" }}>{data.delivery_status}</span>
                                    </div>
                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Driver</span>
                                      <span style={{ display: "block" }}>{data.driver_name}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Quantity</span>
                                      <span style={{ display: "block" }}>{data.inventory_quantity}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Charges</span>
                                      <span style={{ display: "block" }}>&#8377; &nbsp;{data.transport_charges}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Delivered</span>
                                      <span style={{ display: "block" }}>{data.payment_status}</span>

                                    </div>


                                  </div>
                                  <br />
                                  <p style={{ fontSize: "15px", fontWeight: "500" }}>Amount  &nbsp; <span style={{ fontWeight: "500", color: "#E50014" }}>&#8377; {parseInt(data.trip_amount)}</span></p>
                                  {/* <button className='btn ' style={{ backgroundColor: "#f8d62b", color: "white", borderRadius: "20px" }} onClick={() => {
                                    UpdateUser(data.trip_id)
                                  }}><i className='fa fa-edit '></i></button> &nbsp;<button className="btn " style={{ backgroundColor: "#E50014", color: "white", borderRadius: "20px" }} onClick={() => {
                                    DeleteUser(data.trip_id)
                                  }}><i className='fa fa-trash'></i></button> */}
                                  {data.driver_coordinates !== null && data.driver_coordinates !== "" && data.Buyer_coordinate === null || data.Buyer_coordinate === "" ? 

                                    <div className='map-five' key={i} >
                                      <ReactBingmaps
                                        id={data.trip_id}
                                        center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                        zoom={12}
                                        className="customClass"
                                        bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                        pushPins={[





                                          {
                                            location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                            option: { title: data.driver_name, subTitle: "Driver" },


                                          },
                                          {
                                            location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                            option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                          },
                                          // {
                                          //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                          //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                          // }
                                        ]
                                        }















                                      />
                                    </div> :""}
                                    {data.Buyer_coordinate !== null && data.Buyer_coordinate !== "" && data.driver_coordinates !== null && data.driver_coordinates !== "" ?

                                      <div className='map-five' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            {
                                              location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                              option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            }
                                          ]
                                          }















                                        />
                                      </div> :

                                      <div className='map-five' key={i} >
                                        <ReactBingmaps

                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            // {
                                            //     location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                            //     option: { title: data.driver_name, subTitle: "Driver" },


                                            // },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div>
                                      }

                                </div>


                              </CardBody>
                            </Accordion.Collapse>
                          </Card>
                        )


                      })}</> : <Card>
                      <CardHeader >
                        <h5 className="mb-0">
                          <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                            No Record Found
                          </Accordion.Toggle>
                        </h5>
                      </CardHeader>
                    </Card>}
                  </div>

                </Accordion></div>
            </> :
              <Card>





                <CardBody>
                  <div className="table-responsive ">
                    <Table className='table-borderless'>
                      <tbody>
                        <tr style={{ textAlign: "center" }}>
                          <td style={{ verticalAlign: "inherit" }}>
                            <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer" }} onClick={() => {
                              getTripDetail()
                            }}>All</div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input type="date" value={tabtripdate} onChange={(e) => { gettripfilterdata(e.target.value, "date"); settabtripdate(e.target.value) }} />
                            </div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input className="form-control" type="select" value={tabvehicleid} onChange={(e) => {
                                settabvehicleid(e.target.value)
                                gettripfilterdata(e.target.value, "vehicle")
                              }}>
                                <option value={""}>Vehicle</option>
                                {vehicle_detail.map((data, i) => {

                                  return (
                                    <option key={i} value={data.vehicle_id}>{data.vehicle_number}</option>
                                  )
                                })}
                              </Input></div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input className="form-control" type="select" value={tabdriverid} onChange={(e) => {
                                settabdriverid(e.target.value)
                                gettripfilterdata(e.target.value, "driver")
                              }}>
                                <option value={""}>Driver</option>
                                {Driver_detail.map((data, i) => {

                                  return (
                                    <option key={i} value={data.driver_id}>{data.driver_name}</option>
                                  )
                                })}
                              </Input></div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input className="form-control" type="select" value={tabbuyerid} onChange={(e) => {
                                settabbuyerid(e.target.value)
                                gettripfilterdata(e.target.value, "buyer")
                              }}>
                                <option value={""}>Buyer</option>
                                {buyer_detail.map((data, i) => {

                                  return (
                                    <option key={i} value={data.customer_id}>{data.customer_name}</option>
                                  )
                                })}
                              </Input></div>
                          </td>

                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input className="form-control" type="select" placeholder="Enter Delivered At" value={tabdelivery} onChange={(e) => { gettripfilterdata(e.target.value, "delivery"); setabdelivery(e.target.value) }} >
                                <option value={""}>Delivery </option>
                                <option value={"Delivered"}>Delivered</option>
                                <option value={"IN-TRANSIT"}>IN-TRANSIT</option>

                              </Input></div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input className="form-control" type="select" placeholder="Choose Payment By" value={tabpayment} onChange={(e) => { gettripfilterdata(e.target.value, "payment"); settabpayment(e.target.value) }} >
                                <option value={""}>Payment</option>
                                <option value={"Paid"}>Paid</option>
                                <option value={"Pending"}>Pending</option>

                              </Input>
                            </div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <button className="btn " style={{ backgroundColor: "black", color: "white", borderRadius: "7px" }} onClick={() => { downloadpdf() }}>Download PDF</button>
                            </div>
                          </td>
                          <td>
                            <button className='btn btn-primary' style={{ float: "right" }} onClick={() => {
                              LargeModaltoggle(); setedittype("new")
                              seteditid(""); setreturn_trip_status(true); updatereturnstatus(); settrip_status(0)
                            }}>Create Trip</button>
                          </td>


                        </tr>
                      </tbody>
                    </Table>



                    <Table id='trip_table' >
                      <thead>
                        <tr style={{ textAlign: "center" }}>
                          <th scope="col">{"Date"}</th>
                          <th scope="col">{"Vehicle"}</th>
                          <th scope="col">{"Driver"}</th>
                          <th scope="col">{"Quantity"}</th>
                          <th scope="col">{"Inventory"}</th>

                          <th scope="col">{"Buyer"}</th>
                          <th scope="col">{"Transport Distance"}</th>
                          <th scope="col">{"Amount"}</th>

                          <th scope="col">{"Transport Amount"}</th>

                          <th scope="col">{"Delivery"}</th>
                          <th scope="col">{"Payment"}</th>
                          <th scope="col">{"Action"}</th>
                        </tr>
                      </thead>
                      <tbody>

                        {trip_detail.length > 0 ? <>
                          {trip_detail.map((data, i) => {
                            return (
                              <tr key={i} style={{ textAlign: "center" }}>
                                <td><div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div></td>
                                <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_number.substring(0, 6)}</div><div style={{ fontWeight: "700", fontSize: "19px" }}>{data.vehicle_number.substring(6, 10)}</div></div></td>
                                <td>{data.driver_name}</td>
                                <td>{data.inventory_quantity}</td>
                                <td>{data.inventory_type}</td>
                                <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.customer_name}</span></td>
                                <td>{data.transport_distance} Km</td>
                                <td>{data.trip_amount}</td>
                                <td>{data.transport_charges}</td>

                                <td>{data.delivery_status === "IN-TRANSIT" ? <span style={{ textTransform: "uppercase", backgroundColor: "skyblue", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "purple", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span>}</td>

                                <td>{data.payment_status === "Paid" ? <span style={{ textTransform: "uppercase", backgroundColor: "darkgreen", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "orange", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span>}</td>

                                <td><button className='btn btn-warning m-1' onClick={() => {
                                  UpdateUser(data.trip_id)
                                }}><i className='fa fa-edit  '></i></button> &nbsp;<button className='btn btn-danger m-1' onClick={() => {
                                  DeleteUser(data.trip_id)
                                }}><i className='fa fa-trash'></i></button></td>
                              </tr>
                            )
                          })}
                        </>
                          : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}



                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default Trip;